<div class="rs-es-navigation-wrapper" data-es-navigation-wrapper="">
  <nav
    class="rs-es-navigation"
    aria-labelledby="servicesNavLabel"
    role="navigation"
    data-es-navigation=""
  >
    <h2 id="servicesNavLabel" class="show-for-sr">
      {{ 'bills.billsScreen.tabs.screenReader.mainMenu' | translate }}
    </h2>
    <ul class="rs-es-navigation-list" data-es-navigation-list="">
      <li
        [ngClass]="{ 'rs-selected': !isEvolutionTabActive }"
        (click)="onOverviewClick()"
        data-cy="myBillOverviewTab"
      >
        <a href="javascript:void(0)">
          <span class="show-for-sr" *ngIf="!isEvolutionTabActive">{{
            'bills.billsScreen.tabs.screenReader.currentPage' | translate
          }}</span>
          {{ 'bills.billsScreen.tabs.overview' | translate }}
        </a>
      </li>
      <li
        [ngClass]="{ 'rs-selected': isEvolutionTabActive }"
        (click)="onEvolutionClick()"
        data-cy="myBillEvolutionTab"
        data-es-navigation-element=""
      >
        <a href="javascript:void(0)">
          <span class="show-for-sr" *ngIf="isEvolutionTabActive">{{
            'bills.billsScreen.tabs.screenReader.currentPage' | translate
          }}</span>
          {{ 'bills.billsScreen.tabs.evolution' | translate }}
        </a>
      </li>
    </ul>
  </nav>
</div>
